// Tratamento dos valores do formulário antes de enviar para a API
// (ficha de cadastro, filtros de relatório e de dashboard)
export function tratarPayload(payload: Record<string, any>) {
  for (const campo in payload) {
    const valor = payload[campo];

    if (campo === 'codven' && valor === '') {
      payload[campo] = 0;
    }

    if (valor?.toString().endsWith('.00')) {
      payload[campo] = +valor.toString().replace('.00', '');
    }

    // Verifica se é uma data no formato YYYY-MM-DD
    if (typeof valor === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(valor)) {
      const [ano, mes, dia] = valor.split('-');
      payload[campo] = `${dia}/${mes}/${ano}`;
    }

    if (typeof payload[campo] === 'boolean') {
      payload[campo] = payload[campo] ? 1 : 0;
    }
  }

  // codcid pode vir número (ex.: pedsai traz o codcid do vendedor pelo relacionamento)
  if (payload?.codcid) {
    payload.codcid = String(payload.codcid).replace(/\D/g, '');
  }

  return payload;
}
